module.exports = __webpack_public_path__ + "static/media/logo-compras-inverted.a760d1fc.png";